// ** React Imports
import { createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom' // Replacing Next.js router

// ** Axios
import axios from 'axios'

// ** Custom Hook
import { useSmartClaim } from '../hooks/smartClaim' // Adjust path as needed

// ** Defaults
const defaultProvider = {
  user: null,
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve()
}

const AuthContext = createContext(defaultProvider)

const AuthProvider = ({ children }) => {
  // ** States
  const [user, setUser] = useState(defaultProvider.user)
  const [loading, setLoading] = useState(defaultProvider.loading)
  const smartClaim = useSmartClaim()

  // ** Hooks
  const navigate = useNavigate() // React Router hook for navigation

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('email')
      if (storedToken) {
        let user = { email: storedToken }
        setUser(user)
        setLoading(false)
      } else {
        setLoading(false)
        localStorage.removeItem('userData')
        localStorage.removeItem('email')
        navigate('/login') // Replacing Next.js router.push()
      }
    }
    initAuth()
  }, [navigate])

  const handleLogin = (params, errorCallback) => {
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/login`, params)
      .then(response => {
        smartClaim.completedClaim()

        if (params.rememberMe) {
          localStorage.setItem('accessToken', response.data.accessToken)
          localStorage.setItem('userData', JSON.stringify(response.data))
          localStorage.setItem('email', JSON.stringify(params.email))
        }

        setUser({ email: params.email })
        if (errorCallback) errorCallback({ status: 'success' })
        navigate('/dashboard')
      })
      .catch(err => {
        if (errorCallback) errorCallback({ status: 'error', err })
      })
  }

  const handleLogout = () => {
    setUser(null)
    localStorage.removeItem('userData')
    localStorage.removeItem('email')
    localStorage.removeItem('accessToken')
    navigate('/login')
  }

  const values = {
    user,
    loading,
    setUser,
    setLoading,
    login: handleLogin,
    logout: handleLogout
  }

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>
}

export { AuthContext, AuthProvider }
